var $d49d621f310cf6ce$exports = {};
$d49d621f310cf6ce$exports = {
  "Empty": "\u7A7A"
};
export { $d49d621f310cf6ce$exports as default };